import ReactDOM from "react-dom"
import "./index.scss"
import App from "./app/App"
import reportWebVitals from "./reportWebVitals"
import { HashRouter } from "react-router-dom"

import "react-datepicker/dist/react-datepicker.css"
import "ag-grid-community/dist/styles/ag-grid.css"
import "ag-grid-community/dist/styles/ag-theme-alpine.css"

import { Provider } from "react-redux"
import store from "./app/Store"

const rootElement = document.getElementById("root")
ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>,
  rootElement
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
if (module && module["hot"]) {
  module["hot"].accept()
}
